import { BsDiscord } from 'react-icons/bs';
import { FaTelegramPlane, FaTwitter } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './modernFooter.css';

export default function FooterContainer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="modern-footer">
      {/* Navigation Links */}
      <nav className="footer-nav">
        <Link to="/" className="footer-nav-link">
          Home
        </Link>
        <a href="https://invest.scrub.money" className="footer-nav-link">
          Invest
        </a>
        <Link to="/nftcollection" className="footer-nav-link">
          NFT
        </Link>
        <Link to="/singlestake" className="footer-nav-link">
          Tiger Stake
        </Link>
        <a href="https://commerce.scrub.money" className="footer-nav-link">
          Giftcards
        </a>
      </nav>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <div className="footer-copyright">
          Copyright © Scrub Money <span className="footer-year">{currentYear}</span>
        </div>
        
        <div className="footer-social">
          <a 
            href="https://twitter.com/ScrubMoneyDeFi" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-social-link"
            aria-label="Twitter"
          >
            <FaTwitter />
          </a>
          <a 
            href="https://t.me/ScrubMoney" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-social-link"
            aria-label="Telegram"
          >
            <FaTelegramPlane />
          </a>
          <a 
            href="https://discord.gg/dPVjyrUBey" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-social-link"
            aria-label="Discord"
          >
            <BsDiscord />
          </a>
        </div>
      </div>

      {/* Decorative Glow Effect */}
      <div className="footer-glow" />
    </footer>
  );
}
